"use strict";

var _slicedToArray = require("/codebuild/output/src305412778/src/github.com/rteamweb/web-marketing-ui/application/node_modules/@babel/runtime/helpers/slicedToArray.js");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Popper = void 0;

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");

var react_1 = __importDefault(require("react"));

var core_1 = require("@popperjs/core");

var StyledComponents_1 = require("./StyledComponents");

var Popper = function Popper(_ref) {
  var targetEl = _ref.targetEl,
      id = _ref.id,
      _ref$isDisplaying = _ref.isDisplaying,
      isDisplaying = _ref$isDisplaying === void 0 ? false : _ref$isDisplaying,
      _ref$placement = _ref.placement,
      placement = _ref$placement === void 0 ? "bottom" : _ref$placement,
      _ref$offsetX = _ref.offsetX,
      offsetX = _ref$offsetX === void 0 ? 0 : _ref$offsetX,
      _ref$offsetY = _ref.offsetY,
      offsetY = _ref$offsetY === void 0 ? 0 : _ref$offsetY,
      _ref$displayTime = _ref.displayTime,
      displayTime = _ref$displayTime === void 0 ? 2000 : _ref$displayTime,
      className = _ref.className,
      children = _ref.children,
      backColor = _ref.backColor,
      borderColor = _ref.borderColor,
      onClick = _ref.onClick,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? "primary" : _ref$type,
      handlePopperTimedOut = _ref.handlePopperTimedOut,
      _ref$addClass = _ref.addClass,
      addClass = _ref$addClass === void 0 ? "" : _ref$addClass;

  var _react_1$default$useS = react_1.default.useState(false),
      _react_1$default$useS2 = _slicedToArray(_react_1$default$useS, 2),
      hasMounted = _react_1$default$useS2[0],
      setHasMounted = _react_1$default$useS2[1];

  var instance = react_1.default.useRef();
  var timeoutId = react_1.default.useRef();
  react_1.default.useEffect(function () {
    if (hasMounted && isDisplaying) {
      timeoutId = window === null || window === void 0 ? void 0 : window.setTimeout(function () {
        handlePopperTimedOut && handlePopperTimedOut();
      }, displayTime);
    } else if (hasMounted && timeoutId.current && isDisplaying === false) {
      handlePopperTimedOut && handlePopperTimedOut();
      window === null || window === void 0 ? void 0 : window.clearTimeout(timeoutId.current);
      timeoutId.current = undefined;
    }
  }, [isDisplaying]);
  react_1.default.useEffect(function () {
    var _a;

    (_a = instance === null || instance === void 0 ? void 0 : instance.current) === null || _a === void 0 ? void 0 : _a.update();
  }, [instance.current]);
  react_1.default.useEffect(function () {
    setHasMounted(true);
  }, []);

  var showPopper = function showPopper() {
    try {
      if (targetEl instanceof Element) {
        instance.current && instance.current.destroy();
        var toolTip = document === null || document === void 0 ? void 0 : document.querySelector("#tool-tip-".concat(id));
        var popperInstance = (0, core_1.createPopper)(targetEl, toolTip, {
          placement: placement,
          modifiers: [{
            name: "offset",
            options: {
              offset: [offsetX, offsetY]
            }
          }]
        });
        toolTip === null || toolTip === void 0 ? void 0 : toolTip.setAttribute("data-show", "");
        instance.current = popperInstance;
      }
    } catch (_a) {
      return null;
    }
  };

  return (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, {
    children: [isDisplaying && showPopper(), (0, jsx_runtime_1.jsxs)(StyledComponents_1.ToolTip, {
      hasClick: !!onClick,
      addClass: addClass,
      onClick: onClick,
      className: className,
      backColor: backColor,
      borderColor: borderColor,
      id: "tool-tip-".concat(id),
      css: {
        display: isDisplaying ? "content" : "none"
      },
      "data-testid": "popper-tooltip",
      children: [(0, jsx_runtime_1.jsx)(StyledComponents_1.ToolTipArrow, {
        id: "arrow",
        "data-popper-arrow": true
      }), children]
    })]
  });
};

exports.Popper = Popper;